module.exports = __webpack_public_path__ + "static/media/success-action-animation.90dc0258.lottie";